import { render } from "./UserPage.vue?vue&type=template&id=057236aa"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__